import { render, staticRenderFns } from "./MoreMenuItem.vue?vue&type=template&id=6a3db93f&"
import script from "./MoreMenuItem.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports